import { useTranslation, Trans } from 'react-i18next';
import { CUSTODIAL_PROVIDERS, LOCAL_STORAGE } from '@constants';
import BridgeLogo from 'assets/images/bridge-logo.png';
import CustodialProviderCard from 'components/CustodialProviderCard/CustodialProviderCard';

type CustodialProviderSelectorProps = {
  onConnect: (value: string) => Promise<void>;
  showInSettings: boolean;
  className: string;
};

const CustodialProviderSelector = function (props: CustodialProviderSelectorProps) {
  const { onConnect, className, showInSettings } = props;
  const { t } = useTranslation('ENTERPRISE_SIGNUP');
  const defaultProvider = localStorage.getItem(LOCAL_STORAGE.SELECTED_CUSTODIAL_PROVIDER);

  const providers = {
    [CUSTODIAL_PROVIDERS.BRIDGE]: (
      <CustodialProviderCard
        selectable={!showInSettings}
        description={
          showInSettings ? (
            <Trans
              i18nKey="ENTERPRISE_SIGNUP:BRIDGE_CREATE_ACCOUNT_DESCRIPTION_WITH_CTA"
              components={[
                <a
                  href={t('ENTERPRISE_SIGNUP:BRIDGE_CREATE_ACCOUNT_DESCRIPTION_CTA')}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="d-block u-mt-2 text--base text--md"
                  key="brige-link"
                >
                  brige-link
                </a>,
              ]}
            />
          ) : (
            t('WELCOME_BRIDGE_DESCRIPTION')
          )
        }
        brand={<img src={BridgeLogo} alt="bridge" />}
        onClick={!showInSettings ? () => onConnect(CUSTODIAL_PROVIDERS.BRIDGE) : () => {}}
        className="u-my-0"
      />
    ),
  };

  return (
    <div className={className}>
      {defaultProvider
        ? providers[defaultProvider]
        : Object.keys(providers).map((k) => providers[k])}
    </div>
  );
};
export default CustodialProviderSelector;
